import {Cards} from '/constant/TestIDs';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

export type Competency =
  | typeof BUSINESS_COACH
  | typeof BUSINESS_LEADER
  | typeof COACH;

export type OrderSummaryKeys = {
  currentKey: string;
  currentLabel: string;
  currentTestID: string;
  currentTitleTestID: string;
  projectedKey: string;
  projectedLabel: string;
  projectedTestID: string;
  projectedTitleTestID?: string;
  estimatedKey: string;
  estimatedLabel: string;
  estimatedTestID: string;
  estimatedTitleTestID: string;
};

const ORDER_SUMMARY_CONFIG: Record<string, OrderSummaryKeys> = {
  [COACH]: {
    currentKey: 'current.frontline',
    currentLabel: 'Current Frontline Volume',
    currentTestID: Cards.cardCurrentFrontlineVolumeValue,
    currentTitleTestID: Cards.cardCurrentFrontlineVolumeTitle,
    projectedKey: 'projected.frontline',
    projectedLabel: 'Remaining Projected FQV',
    projectedTestID: Cards.cardProjectedFrontlineVolumeValue,
    projectedTitleTestID: Cards.cardProjectedFrontlineVolumeTitle,
    estimatedKey: 'estimated.frontline',
    estimatedLabel: 'Total Projected Frontline Volume',
    estimatedTestID: Cards.cardTotalFrontlineVolumeValue,
    estimatedTitleTestID: Cards.cardTotalFrontlineVolumeTitle,
  },

  [BUSINESS_COACH]: {
    currentKey: 'current.gen0',
    currentLabel: 'Current Generation 0 Volume',
    currentTestID: Cards.cardCurrentGen0VolumeValue,
    currentTitleTestID: Cards.cardCurrentGen0VolumeTitle,
    projectedKey: 'projected.gen0',
    projectedLabel: 'Remaining Projected Gen0 Volume',
    projectedTestID: Cards.cardProjectedGen0VolumeValue,
    projectedTitleTestID: Cards.cardProjectedGen0VolumeTitle,
    estimatedKey: 'estimated.gen0',
    estimatedLabel: 'Total Projected Gen0 Volume',
    estimatedTestID: Cards.cardTotalGen0VolumeValue,
    estimatedTitleTestID: Cards.cardTotalGen0VolumeTitle,
  },

  [BUSINESS_LEADER]: {
    currentKey: 'current.org',
    currentLabel: 'Current TGen Volume',
    currentTestID: Cards.cardCurrentTGenVolumeValue,
    currentTitleTestID: Cards.cardCurrentTGenVolumeTitle,
    projectedKey: 'projected.org',
    projectedLabel: 'Remaining Projected TGenV',
    projectedTestID: Cards.cardProjectedTGenVolumeValue,
    projectedTitleTestID: Cards.cardProjectedTGenVolumeTitle,
    estimatedKey: 'estimated.org',
    estimatedLabel: 'Estimated TGenV',
    estimatedTestID: Cards.cardTotalTGenVolumeValue,
    estimatedTitleTestID: Cards.cardTotalTGenVolumeTitle,
  },
};

export function getOrderSummaryKeys(
  currentUserCompetency: Competency,
): OrderSummaryKeys {
  const config = ORDER_SUMMARY_CONFIG[currentUserCompetency];

  if (!config) {
    throw new Error(`Unsupported competency: ${currentUserCompetency}`);
  }

  return {
    ...config,
  };
}
